module.exports = identity

/**
 * Set a quat to the identity quaternion
 *
 * @param {quat} out the receiving quaternion
 * @returns {quat} out
 */
function identity (out) {
  out[0] = 0
  out[1] = 0
  out[2] = 0
  out[3] = 1
  return out
}



//////////////////
// WEBPACK FOOTER
// ./~/gl-quat/identity.js
// module id = 1269
// module chunks = 0